import { BiTimeGrain } from '@euler/model/bi/query';
import { BiVizType } from '@euler/model/bi/viz';

export const kBiGrainLabels: Record<BiTimeGrain, string> = {
  [BiTimeGrain.Day]: '按日',
  [BiTimeGrain.Week]: '按周',
  [BiTimeGrain.Month]: '按月',
  [BiTimeGrain.Quarter]: '按季度',
  [BiTimeGrain.Year]: '按年',
};

export const kBiVizTypeLabels: Record<BiVizType, string> = {
  [BiVizType.Kpi]: '指标卡',
  [BiVizType.KpiGroup]: '指标组',
  [BiVizType.Line]: '折线图',
  [BiVizType.Area]: '面积图',
  [BiVizType.Bar]: '柱状图',
  [BiVizType.HorizontalBar]: '条形图',
  [BiVizType.StackedBar]: '堆叠柱状图',
  [BiVizType.Pie]: '饼图',
  [BiVizType.Donut]: '环形图',
  [BiVizType.Radar]: '雷达图',
  [BiVizType.Pyramid]: '金字塔图',
  [BiVizType.Funnel]: '漏斗图',
  [BiVizType.Table]: '表格',
};
